import React, { Component } from 'react';
import { CircleLoaderComponent } from 'react/CircleLoaderComponent';

export default class PlayOptionComponent extends Component {
	constructor(props) {
		super(props);
		const { onClick, option, matchSearchListManager } = this.props;
		const { gameCount, isRanked, teamSize, ladderId } = option;

		this.onClick = onClick.bind(this, option);
		const players = [];
		players.push(myUser);
		if(option.player) {
			players.push(option.player);
		}
		if(matchSearchListManager) {
			this.hasMatchWithCriteria = () => {
				const match = matchSearchListManager.hasMatchWithCriteria({
						players,
						ladderId,
						gameCount,
						isRanked,
						teamSize,
						isSearch: true
					}
				);
				if(!match) {
					return false;
				}
				return true;
			};
		}

	}

	render() {
		const { option, gameTypeIsPending, content } = this.props;

		const title = option.getTitle();

		const isPending = gameTypeIsPending ? gameTypeIsPending(option) : false;
		const disabled = (isPending && this.hasMatchWithCriteria) || (this.hasMatchWithCriteria ? this.hasMatchWithCriteria() : null);

		return (
			<div className='button_container'>
				<button
					className={`active_selectable_button game_settings_selection game_setting btn shadowed-btn ${disabled ? 'disabled' : ''} ${isPending ? 'pending' : ''}`}
					onClick={this.onClick}
				>
					{content ||
					<span className="selection_name">
						{isPending &&
						<div className='loading'>
							<CircleLoaderComponent
								strokeWidth={2}
								circleSize={20}
							/>
						</div>
						}
						<span className="name">{title}</span>
					</span>
					}
				</button>
			</div>
		);
	}
}